<ng-container *abcLet="res$ | async as res">
  <div
    #filterDiv
    [ngClass]="frame?.rtlEnabled ? 'resTypeFilterRtl' : 'resTypeFilter'"
    [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  >
    <div class="chip-container">
      <mat-chip-set multiple="true">
        @for (resType of this.dataContext?.dsResourceTypes; track resType) {
          <mat-chip
            [selected]="resType.selected"
            [class.selected]="resType.selected"
            (click)="resourceTypeChipClick(resType)"
            >{{ resType.name }}</mat-chip
          >
        }
      </mat-chip-set>
    </div>
  </div>
  <div class="grid-button-container">
    <mat-button-toggle (click)="toggleEventGridView()">
      <mat-icon class="gridButtonIcon" [svgIcon]="res.svgName('Resource-Grid-Image')"></mat-icon>
    </mat-button-toggle>
  </div>
  <div id="resPanel" class="resPanel" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
    @if (!isGridVisible) {
      <div class="gapLeft gapBottom" fxLayout="row wrap" fxLayoutGap="25px grid">
        @for (resource of this.getFilteredResources(); track resource) {
          <div class="res-card">
            <mat-card class="resource-card">
              <mat-card-header class="cardHeader">
                <mat-icon mat-card-avatar [svgIcon]="res.svgName(resource.resourceType.iconName)"></mat-icon>
                <mat-card-title class="resource-card-title">{{ resource.name }}</mat-card-title>
                <mat-card-subtitle>{{ resource.resourceType.name }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content class="resource-card-content">
                <ul class="resource-card-list-content">
                  @for (resourceEvtGroup of resource.resourceEventGroups; track resourceEvtGroup) {
                    <li>
                      {{ resourceEvtGroup.summaryText }}
                    </li>
                  }
                </ul>
              </mat-card-content>
              <mat-card-actions class="cardActions">
                @for (
                  resourceEvtTypeGroup of resource.resourceType.resourceEventTypeGroups;
                  track resourceEvtTypeGroup
                ) {
                  <button
                    class="resourceIcon"
                    mat-icon-button
                    (click)="resourceCardActionClick(resource, resourceEvtTypeGroup)"
                  >
                    <mat-icon [svgIcon]="res.svgName(resourceEvtTypeGroup.iconName)"></mat-icon>
                  </button>
                }
              </mat-card-actions>
            </mat-card>
          </div>
        }
      </div>
    } @else {
      <abc-grid
        [ngClass]="'gapLeft gapRight gridBottomGap'"
        [ngClass.xs]="''"
        #abcGridResourceEvent
        [setupDefaultLayoutOnInitialization]="true"
        [dataSourceObject]="{
          dataSource: this.resourceListService.getResourceEvents(),
          gridColumns: this.gridColumns,
          storage: this.storage,
          storageKey: 'resourcesGrid',
        }"
        [rtlEnabled]="frame?.rtlEnabled"
        class="abc-grid-opera-resources-grid"
      >
      </abc-grid>
    }
  </div>
</ng-container>
